import React, { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { myApi } from '../../../../../config/axiosConfig';
import { Grid2, Button } from '@mui/material';
import Swal from 'sweetalert2';

// ICONOS
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

// COMPONENTES
import MiTabla from '../../../../../components/plantilla/tabla/MiTabla';
import BtnAcciones from '../../../../../components/plantilla/tabla/BtnAcciones';
import ModalAgregarUnidad from './modales/ModalAgregarUnidad';

const UnidadesActivas = () => {

    const isNonMobile = useMediaQuery("(min-width:600px)");

    // =========================================
    // FUNCION PARA BUSCAR UNIDADES ACTIVAS
    // =========================================

    const [unidadesActivas, setUnidadesActivas] = useState([]);

    const getUnidadesActivas = async () => {

        try {

            const response = await myApi.get('/telematica/unidades/activas');

            setUnidadesActivas(response.data.data)

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // FUNCION PARA BUSCAR TRACTORES
    // =========================================

    const [tractores, setTractores] = useState([]);

    const buscarTractores = async () => {

        try {

            const response = await myApi.get('/tractores/select2');

            setTractores(response.data)

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // FUNCION PARA BUSCAR CAJAS
    // =========================================

    const [cajas, setCajas] = useState([]);

    const buscarCajas = async () => {

        try {

            const response = await myApi.get('/cajas/select2');

            setCajas(response.data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // FUNCION PARA BUSCAR CLIENTES
    // =========================================

    const [clientes, setClientes] = useState([]);

    const buscarClientes = async () => {

        try {

            const response = await myApi.get('/telematica/clientes/select');

            setClientes(response.data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // COLUMNAS PARA TABLA
    // =========================================

    const columns = [

        { 
            field: 'telematica_cliente', 
            headerName: 'Cliente',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'tractor', 
            headerName: 'Tractor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'tractor_placas', 
            headerName: 'Placas',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'caja', 
            headerName: 'Caja',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'caja_placas', 
            headerName: 'Placas',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleDelete(params.row.id, params.row.caja, params.row.tractor, params.row.telematica_cliente)}
                />
            ],
        }

    ];

    // =========================================
    // FUNCION PARA ELIMINAR UNIDADES
    // =========================================

    const handleDelete = ( idRegistro, caja, tractor, cliente ) => {

        Swal.fire({
            icon: 'question',
            title: 'Desea Eliminar la Unidad ?',
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Eliminar"
        }).then( async (result) => {

            if(result.isConfirmed){

                try {

                    const response = await myApi.delete(`/telematica/eliminar/unidad/${idRegistro}/${caja}/${tractor}/${cliente}`);
        
                    if(response.data.success){
        
                        Swal.fire({
                            icon: 'success',
                            title: 'Unidad Eliminada'
                        })

                        getUnidadesActivas();
        
                    } else {
        
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al Eliminar Unidad'
                        })
        
                    }
        
                } catch( e ) {
        
                    console.log(e)
        
                }

            }

        })

    }

    // =========================================
    // ESTADO DEL MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);

    const handleModal = () => {

        setShowModal(!showModal);

    }

    // =========================================
    // USE EFFECT PARA LLAMAR DATOS
    // =========================================

    useEffect(() => {

        buscarTractores();
        buscarCajas();
        buscarClientes();
        getUnidadesActivas();

    },[]);

    // =========================================

    return (

        <Grid2 container>

            {/* BOTON PARA AGREGAR UNIDADES */}

            <Grid2 
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: isNonMobile ? 'flex-end' : 'start'
                }}
            >

                <Button
                    variant="contained"
                    startIcon={<AddCircleIcon />}
                    onClick={handleModal}
                    sx={{ backgroundColor: 'black', marginBottom: 1 }}
                >
                    Agregar Unidades
                </Button>

            </Grid2>

            {/* TABLA */}

            <Grid2 size={12} marginTop={1}>

                <MiTabla
                    columns={columns}
                    data={unidadesActivas}
                />

            </Grid2>

            {/* MODAL AGREGAR UNIDADES */}

            <ModalAgregarUnidad
                open={showModal}
                onClose={handleModal}
                refresh={getUnidadesActivas}
                cajas={cajas}
                tractores={tractores}
                clientes={clientes}
            />

        </Grid2>

    )

}

export default UnidadesActivas